/* tslint:disable: jsx-no-lambda */
import * as React from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Grid,
  FormControl,
  FormLabel,
  Typography,
  Select,
  MenuItem,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';

import InputField from 'components/Global/InputLabel/InputLabel';
import { useStyles } from './styles';
import { BootstrapInput } from 'components/Global/PickerSelect/PickerSelect';
import { IUserData } from 'types/CarsQuotation/IUserData';
import { DATE_INVALID, REQUIRED_FIELD } from 'constants/notifyConstants';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { CALENDAR_DATE_VALIDATION } from 'constants/index';

const UserData: React.FC<IUserData> = ({
  control,
  civilStatusItems,
  documentTypeItems,
  stratumItems,
  educationLevelItems,
  occupationItems,
  professionItems,
  errors,
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12} sm={3}>
        <Controller
          as={InputField}
          name="firstName"
          label="Nombres"
          autoComplete="given-name"
          id="firstName"
          required
          control={control}
          rules={{
            required: REQUIRED_FIELD,
          }}
        />
        {errors.firstName && errors.firstName.type === 'required' && (
          <Typography variant="caption" display="block" gutterBottom style={{ color: 'red' }}>
            {errors.firstName.message}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={3}>
        <Controller
          as={InputField}
          name="lastName"
          label="Apellidos"
          autoComplete="family-name"
          id="lastName"
          required
          control={control}
          rules={{
            required: REQUIRED_FIELD,
          }}
        />
        {errors.lastName && errors.lastName.type === 'required' && (
          <Typography variant="caption" display="block" gutterBottom style={{ color: 'red' }}>
            {errors.lastName.message}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl component="fieldset">
          <FormLabel component="legend" className={classes.label}>
            Género:
          </FormLabel>
          <Controller
            as={
              <RadioGroup aria-label="gender" row>
                <FormControlLabel value="f" control={<Radio color="primary" />} label="Femenino" />
                <FormControlLabel value="m" control={<Radio color="primary" />} label="Masculino" />
              </RadioGroup>
            }
            defaultValue={false}
            name="gender"
            control={control}
            rules={{
              required: REQUIRED_FIELD,
            }}
          />
          {errors.gender && errors.gender.type === 'required' && (
            <Typography variant="caption" display="block" gutterBottom style={{ color: 'red' }}>
              {errors.gender.message}
            </Typography>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography className={classes.label}>Fecha de Nacimiento</Typography>
        <Controller
          name="fBorn"
          control={control}
          render={({ value, onChange }) => (
            <NumberFormat
              customInput={InputField}
              value={value}
              onValueChange={(e: NumberFormatValues) => onChange(e.formattedValue)}
              format="##/##/####"
              placeholder="DD/MM/YYYY"
              mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
            />
          )}
          rules={{
            required: REQUIRED_FIELD,
            pattern: {
              value: CALENDAR_DATE_VALIDATION,
              message: DATE_INVALID,
            },
          }}
        />
        {errors.fBorn && errors.fBorn.type && (
          <Typography variant="caption" display="block" gutterBottom style={{ color: 'red' }}>
            {errors.fBorn.message}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl className={classes.margin}>
          <Typography className={classes.label}>Estado Civil</Typography>
          <Controller
            as={
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                input={<BootstrapInput />}>
                {civilStatusItems.map((menuItem: any, index: any) => (
                  <MenuItem key={index} value={menuItem.value}>
                    {menuItem.label}
                  </MenuItem>
                ))}
              </Select>
            }
            control={control}
            name="civilState"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl className={classes.margin}>
          <Typography className={classes.label}>Tipo Documento</Typography>
          <Controller
            as={
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                input={<BootstrapInput />}>
                {documentTypeItems.map((menuItem: any, index: any) => (
                  <MenuItem key={index} value={menuItem.value}>
                    {menuItem.label}
                  </MenuItem>
                ))}
              </Select>
            }
            control={control}
            name="documentType"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Controller
          as={InputField}
          control={control}
          name="nDocument"
          label="Número de Documento"
          id="document"
          required
          type="number"
          defaultValue={false}
          rules={{
            required: REQUIRED_FIELD,
          }}
        />
        {errors.nDocument && errors.nDocument.type === 'required' && (
          <Typography variant="caption" display="block" gutterBottom style={{ color: 'red' }}>
            {errors.nDocument.message}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl className={classes.margin}>
          <Typography className={classes.label}>Estrato</Typography>
          <Controller
            as={
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                input={<BootstrapInput />}>
                {stratumItems.map((menuItem: any, index: any) => (
                  <MenuItem key={index} value={menuItem.value}>
                    {menuItem.label}
                  </MenuItem>
                ))}
              </Select>
            }
            control={control}
            name="stratum"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl className={classes.margin}>
          <Typography className={classes.label}>Nivel Educativo</Typography>
          <Controller
            as={
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                input={<BootstrapInput />}>
                {educationLevelItems.map((menuItem: any, index: any) => (
                  <MenuItem key={index} value={menuItem.value}>
                    {menuItem.label}
                  </MenuItem>
                ))}
              </Select>
            }
            control={control}
            name="levelEducation"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl className={classes.margin}>
          <Typography className={classes.label}>Ocupación</Typography>
          <Controller
            as={
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                input={<BootstrapInput />}>
                {occupationItems.map((menuItem: any, index: any) => (
                  <MenuItem key={index} value={menuItem.value}>
                    {menuItem.label}
                  </MenuItem>
                ))}
              </Select>
            }
            control={control}
            name="occupation"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl className={classes.margin}>
          <Typography className={classes.label}>Profesión</Typography>
          <Controller
            as={
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                input={<BootstrapInput />}>
                {professionItems.map((menuItem: any, index: any) => (
                  <MenuItem key={index} value={menuItem.value}>
                    {menuItem.label}
                  </MenuItem>
                ))}
              </Select>
            }
            control={control}
            name="profession"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Controller
          as={InputField}
          control={control}
          name="nChildren"
          label="Número de Hijos"
          id="nChildren"
          type="number"
          defaultValue={0}
          rules={{ min: { value: 0, message: 'Valor mínimo: 0' } }}
        />
        <Typography variant="caption" display="block" gutterBottom style={{ color: '#888' }}>
          Aplica para cotización Mapfre
        </Typography>
      </Grid>
    </>
  );
};

export default UserData;
